import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth, db, collection, addDoc, serverTimestamp, doc, updateDoc, query, where, getDocs } from '../firebase';
import './myreflectionbeforeclassify.css';

export default function MyReflectionBeforeClassify() {
    const navigate = useNavigate();
    const location = useLocation();
    const dateStr = location.state?.dateStr;

    const [journalFreq, setJournalFreq] = useState('Once in 3 days');
    const [selectedMood, setSelectedMood] = useState(null);
    const [otherText, setOtherText] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isFreeformModalOpen, setIsFreeformModalOpen] = useState(false);

    const handleNext = () => {
        if (selectedMood === 'other') {
            handleSubmitOther();
        } else if (selectedMood) {
            navigate('/emotion-selection', { state: { moodType: selectedMood, dateStr: dateStr } });
        } else {
            alert('Please select Positive, Negative, or Other to continue.');
        }
    };

    const handleSubmitOther = async () => {
        const currentUser = auth.currentUser;
        if (!currentUser) {
            alert('Please sign in to journal.');
            return;
        }
        if (!otherText.trim()) {
            alert('Please write something in the other field to continue.');
            return;
        }

        setIsSubmitting(true);
        const finalDateToUse = dateStr || new Date().toISOString().split('T')[0];

        const payload = {
            email: currentUser.email,
            emotion: "Words can't describe",
            moodType: "other",
            other: otherText,
            behaviour: "",
            thoughts: otherText,
            situations: "",
            need: "",
            makes: "",
            entry_time: finalDateToUse,
            Date: finalDateToUse
        };

        try {
            await addDoc(collection(db, "journals"), {
                ...payload,
                createdAt: serverTimestamp()
            });

            try {
                const q = query(collection(db, "users"), where("uid", "==", currentUser.uid));
                const querySnapshot = await getDocs(q);
                if (!querySnapshot.empty) {
                    const userDoc = querySnapshot.docs[0];
                    await updateDoc(doc(db, "users", userDoc.id), {
                        lastJournaledAt: serverTimestamp()
                    });
                }
            } catch (err) {
                console.error("Error updating user lastJournaledAt:", err);
            }

            navigate("/reflection-form", {
                state: {
                    existingData: payload,
                    formattedDate: finalDateToUse,
                    isSubmittedNow: true
                }
            });
        } catch (error) {
            console.error("Firestore Error:", error);
            alert("Error saving journal: " + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="mrbc-container">
            {/* <img
                src="/reflections/top_halfcoloredcircles_bg.png"
                alt="Top circles background"
                className="mrbc-top-bg-img"
            /> */}

            <div className="mrbc-content">
                <div className="mrbc-title-section">
                    <div className="mrbc-sun-bg"></div>
                    <img
                        src="/reflections/nabilogo.png"
                        alt="Wings Logo"
                        className="mrbc-logo-img"
                    />
                </div>

                <div className="mrbc-header-row">
                    <button className="mrbc-back-btn" onClick={() => navigate(-1)}>
                        <span className="mrbc-fallback-back">←</span>
                    </button>
                    <h1 className="mrbc-title">New Reflections</h1>
                </div>
                <div className="mrbc-main-split">
                    <div className="mrbc-left-text">
                        <p className="mrbc-paragraph mrbc-text-dark">
                            Have you thought about all the events & choices that happened for you to come into this world? Here you are, present with all the experiences which have shaped you into who you are. Some positive, some negative, yet it’s all a part of you completing you.
                        </p>
                        <p className="mrbc-paragraph mrbc-text-dark">
                            Reflecting on your feelings, thoughts, actions as well as the emotions that drive them, helps you to get a deeper understanding of yourself.
                        </p>

                        <p className="mrbc-paragraph mrbc-text-light">
                            The answers are always there, we only have to ask the right questions. We are the enablers in this inner journey of yours. It’s truly our wish to see you empowered from within.
                        </p>
                    </div>

                    <div className="mrbc-right-cards">
                        {/* Mood Selection Cards */}
                        <div className="mrbc-selection-cards">
                            <div
                                className={`mrbc-mood-card ${selectedMood === 'positive' ? 'selected' : ''}`}
                                onClick={() => setSelectedMood('positive')}
                            >
                                <div className="mrbc-mood-icon-wrapper">
                                    <img src="/reflections/pos.png" alt="Positive" className="mrbc-mood-icon" />
                                </div>
                                <span className="mrbc-mood-text">I had a good day!</span>
                            </div>
                            <div
                                className={`mrbc-mood-card ${selectedMood === 'negative' ? 'selected' : ''}`}
                                onClick={() => setSelectedMood('negative')}
                            >
                                <div className="mrbc-mood-icon-wrapper">
                                    <img src="/reflections/neg.png" alt="Negative" className="mrbc-mood-icon" />
                                </div>
                                <span className="mrbc-mood-text">I didn't have a great day.</span>
                            </div>
                            <div 
                                className={`mrbc-mood-card ${selectedMood === 'other' ? 'selected' : ''}`}
                                onClick={() => {
                                    setSelectedMood('other');
                                    setIsFreeformModalOpen(true);
                                }}
                            >
                                <div className="mrbc-mood-icon-wrapper">
                                    <div className="mrbc-mood-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem' }}>✍️</div>
                                </div>
                                <span className="mrbc-mood-text">Describe in words...</span>
                            </div>
                        </div>

                        {/* Next Button Footer moved here */}
                        <div className="mrbc-footer-action">
                            {selectedMood !== 'other' && (
                                <button className="mrbc-next-btn" onClick={handleNext} disabled={isSubmitting}>
                                    {isSubmitting ? 'Submitting...' : 'Next'}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/* <div>
            
            <img
                src="/mountains.png"
                alt="Mountains bottom background"
                className="mrbc-bottom-bg-img"
            /> 
            </div> */}

            {/* Freeform Journaling Modal */}
            {isFreeformModalOpen && (
                <div className="es-freeform-overlay" onClick={() => setIsFreeformModalOpen(false)}>
                    <div className="es-freeform-modal" onClick={e => e.stopPropagation()}>
                        <button 
                            className="es-freeform-close" 
                            onClick={() => setIsFreeformModalOpen(false)}
                            style={{ background: 'transparent', border: 'none', cursor: 'pointer', zIndex: 99999, display: 'flex' }}
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                        <div className="es-freeform-header-img"></div>
                        <h2 className="es-freeform-title">It's okay not to have the words</h2>
                        <p className="es-freeform-subtitle">Take a deep breath. Write whatever comes to your mind. This is your safe space.</p>
                        <textarea
                            className="es-freeform-textarea"
                            placeholder="I'm feeling..."
                            value={otherText}
                            onChange={(e) => setOtherText(e.target.value)}
                            autoFocus
                        />
                        <div className="es-freeform-modal-actions">
                            <button 
                                className="es-freeform-submit-btn" 
                                onClick={handleSubmitOther}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Saving gently...' : 'Save to my journal'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
